/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  PlatformKillswitchPrescription,
  PlatformKillswitchPrescription$inboundSchema,
} from "./platformkillswitchprescription.js";

export type ListPrescriptionsResponseBody = {
  /**
   * Cursor for the next page; empty when exhausted.
   */
  nextAfterId?: string | undefined;
  prescriptions: Array<PlatformKillswitchPrescription>;
};

/** @internal */
export const ListPrescriptionsResponseBody$inboundSchema: z.ZodMiniType<
  ListPrescriptionsResponseBody,
  unknown
> = z.pipe(
  z.object({
    next_after_id: z.optional(z.string()),
    prescriptions: z.array(PlatformKillswitchPrescription$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_after_id": "nextAfterId",
    });
  }),
);

export function listPrescriptionsResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<ListPrescriptionsResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListPrescriptionsResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListPrescriptionsResponseBody' from JSON`,
  );
}
